import { BrowserStorageService } from '@/browser-storage';
import { Usuario } from '@/models';
import React, { useEffect } from 'react';
import { useApiClient } from './use-api-client';
import { useCachedState } from './use-cached-state';

const storage = new BrowserStorageService<Usuario>('@/hooks/use-usuario');

export function useUsuario(isSignedIn: boolean, empresaId: string | null): Usuario {
  const apiRequestConfig = React.useMemo(
    () => ({
      url: `layout/usuario/${empresaId}`
    }),
    [empresaId]
  );

  const [usuario, setUsuario] = useCachedState(storage);
  const { request, response } = useApiClient(apiRequestConfig);

  useEffect(() => {
    if (!isSignedIn || !empresaId) {
      setUsuario(null);
      return;
    }

    request();
  }, [isSignedIn, empresaId, request, setUsuario]);

  useEffect(() => {
    if (!response) return;

    setUsuario(response.data);
  }, [response, setUsuario]);

  return usuario ?? {};
}
